module.exports = __webpack_public_path__ + "static/media/sdmt9.487de4a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdmt/sdmt9.svg
// module id = 349
// module chunks = 0